export const bannerVariants = {
  default: 'default',
  warning: 'warning',
  error: 'error',
};

export const defaultBannerVariant = bannerVariants.default;
